module.exports = __webpack_public_path__ + "static/media/GL (1).f2c541c3.svg";